import { useEffect } from 'react'
import { useNotesStore } from '../store/notesStore'
import { useTagsStore } from '../store/tagsStore'

export const useNotes = () => {
  const {
    notes,
    selectedNoteId,
    isLoading,
    error,
    searchQuery,
    filteredNotes,
    fetchNotes,
    createNote,
    updateNote,
    deleteNote,
    selectNote,
    setSearchQuery,
    clearError
  } = useNotesStore()

  const { updateTagNoteCounts } = useTagsStore()

  // Initialize notes on mount
  useEffect(() => {
    fetchNotes()
  }, [fetchNotes])

  // Get currently selected note
  const selectedNote = notes.find(note => note.id === selectedNoteId) || null

  // Enhanced create note that also updates tag counts
  const createNoteWithTagUpdate = async (title?: string) => {
    const note = await createNote(title)
    if (note) {
      await updateTagNoteCounts()
    }
    return note
  }

  // Enhanced delete note that also updates tag counts
  const deleteNoteWithTagUpdate = async (id: string) => {
    await deleteNote(id)
    await updateTagNoteCounts()
  }

  return {
    // State
    notes: filteredNotes,
    allNotes: notes,
    selectedNote,
    selectedNoteId,
    isLoading,
    error,
    searchQuery,
    
    // Actions
    fetchNotes,
    createNote: createNoteWithTagUpdate,
    updateNote,
    deleteNote: deleteNoteWithTagUpdate,
    selectNote,
    setSearchQuery,
    clearError,
    
    // Computed
    notesCount: notes.length,
    filteredNotesCount: filteredNotes.length,
    hasNotes: notes.length > 0,
    hasSelectedNote: !!selectedNote
  }
}